<!-- Sidebar -->
<div class="sidebar-content" [class.height-sidebar]="!hasGlobalMessages()"
  [class.height-sidebar-global-message]="hasGlobalMessages()">

  <div class="sidebar__body">
    <!-- CATEGORIES -->
    @if (!isMobile()) {
    <section class="d-flex flex-column gap-3 animated fadeInLeft">

      <nav class="sidebar-content__menu">
        @for (item of sidebarService.sidebarMenu(); track item.id) {
        <details [open]="item.checked" name="subcategory">

          <summary [ngClass]="{'h5-regular': !item.checked, 'h5-semibold text-primary': item.checked}"
            (click)="goToShopSection(item, $event)">
            {{item.name}}
          </summary>

          @if (item.sublist && item.sublist.length) {
          <ul class="mt-2">
            @for (sublist of item.sublist; track sublist.key) {
            <li [class.subcategory-selected]="sublist.checked">
              <span [class.subcategory-span-selected]="sublist.checked" (click)="goToShopSection(sublist, $event)">
                {{sublist.name}}
              </span>
              <ul>
                @for (sublistSon of sublist.sublist; track sublistSon.key) {
                <li [class.subcategory-selected]="sublistSon.checked">
                  <span [class.subcategory-span-selected]="sublistSon.checked"
                    (click)="goToShopSection(sublistSon, $event)">
                    {{sublistSon.name}}
                  </span>
                </li>
                }
              </ul>
            </li>
            }
          </ul>
          }
        </details>
        }
      </nav>

    </section>
    }
    <!-- FILTERS -->
    <section class="d-flex flex-column gap-3 sidebar-content__filters">

      <h6 class="h6-semibold">
        Filters
      </h6>

      <!-- Tags -->
      @if (sidebarService.filterTags().length) {
      <div class="tags">
        @for (item of sidebarService.filterTags(); track item.listId + '-' + item.sublistId) {
        <div class="tags__tag">
          <span>
            {{item.name}}
          </span>
          <i class="material-symbols-outlined" (click)="sidebarService.removeTag(item)">
            close
          </i>
        </div>
        }
      </div>
      }

      <!-- Details -->
      <div class="accordion" id="accordionSidebar">
        @for (item of sidebarService.sidebar(); track itemIndex; let itemIndex = $index) {
        <div class="accordion-item border-0">
          <h2 class="accordion-header animated fadeInLeft">
            <button class="accordion-button text-capitalize gap-2" type="button" data-bs-toggle="collapse"
              [attr.data-bs-target]="'#' + item.id" aria-expanded="true" [attr.aria-controls]="'#' + item.id">
              {{ item.name }} @if(item.countActiveFilters) {<span class="quantity">{{item.countActiveFilters}}</span>}
            </button>
          </h2>
          <div [id]="item.id" class="accordion-collapse collapse show">
            <div class="accordion-body">
              <ul>
                @for (sublist of item.sublist; track $index) {
                <li>
                  <mat-checkbox [(ngModel)]="sublist.checked" class="animated fadeInLeft"
                    [disabled]="!!sublist.disabled" (ngModelChange)="sidebarService.handleCheckChange(item, sublist)">
                    {{ sublist.name }}
                  </mat-checkbox>
                </li>
                }
              </ul>
            </div>
          </div>
        </div>
        }
      </div>

    </section>
  </div>

  <h5 class="sidebar__title animated fadeInLeft">
    {{ signalsStore.selectedCategory().name || '' }}
  </h5>

</div>